import { BookingType } from "@App/Components/BookingType";
import { Modal } from "@App/Components/Modal";
import { AdditionalBookingInformation } from "@App/Components/Partials/AdditionalBookingInformation";
import type { Garage, Organization, Service, Slot } from "@App/types";
import { GarageIsBookableOnArval } from "@App/utils/conditionals/combinations";
import { OrganizationIsItzehoer } from "@App/utils/conditionals/organization";
import { ServiceIsVehicleReturn } from "@App/utils/conditionals/services";
import { formatDate } from "@App/utils/dates";
import { Fragment, type FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

type SelectedHintProps = {
  garage: Garage;
  selectedSlot: Slot;
  service: Service;
  organization: Organization;
};

export const SelectedHint: FunctionComponent<SelectedHintProps> = (props: SelectedHintProps) => {
  const { t } = useTranslation();
  const [modalOpened, setModalOpened] = useState(false);

  return (
    <Fragment>
      <div className="mt-5">
        <div>
          {t("booking.chosen-slot")}{" "}
          {props.selectedSlot && (
            <span className="font-bold">
              {formatDate(props.selectedSlot.starts_at, "dd.MM.yyyy")} um{" "}
              {formatDate(props.selectedSlot.starts_at, "HH:mm")} Uhr
            </span>
          )}
        </div>
        {props.service &&
          !ServiceIsVehicleReturn(props.service) &&
          !OrganizationIsItzehoer(organization) && (
            <div className={"flex text-sm lg:text-base gap-3 lg:gap-4 mt-3 lg:mt-0"}>
              {GarageIsBookableOnArval(props.organization, props.garage) && (
                <BookingType liveBookable={props.garage.liveBookable} mobileVisible />
              )}
            </div>
          )}
        <p className="text-sm font-medium">{t("booking.calendarDisclaimer")}</p>
        {props.service && ServiceIsVehicleReturn(props.service) && (
          <div
            className={"font-bold"}
            dangerouslySetInnerHTML={{ __html: t("booking.hint") }}
          ></div>
        )}
      </div>
      <Modal
        title={t("booking.moreInformation.headline")}
        width="max-w-3xl"
        open={modalOpened}
        showButton={false}
        onClick={() => setModalOpened(false)}
        onClose={() => setModalOpened(false)}
      >
        <AdditionalBookingInformation
          garage={props.garage}
          organization={organization}
          service={props.service}
        />
      </Modal>
    </Fragment>
  );
};
